$ = require 'jquery'
h = require './helpers'

Observer = require './../components/observer'

images_url = '//www.tourtrans.ru/js/online-styles/new/'
backend_url = '//admin.tourtrans.ru';

SimpleBasket = require './simple_basket'
#
# Шаблон TTV_online_individual.jpg
#
# #ctl00_generalContent_UpdatePanel1 - общая панель
class Basket extends SimpleBasket
  elements: ->
    this.$servicesTable = $('#ctl00_generalContent_BasketServices_DgBasketServices')
    this.$panel = $('#ctl00_generalContent_UpdatePanel1')
    this.$form = $('#aspnetForm')

    this.$submitButton = $('#ctl00_generalContent_BtnOrder')

    # Переписка с менеджером
    this.$mFIO = $ '#ctl00_generalContent_AdvBasketManagerInfo_txtManagerFIO' # ФИО
    this.$mPhone = $ '#ctl00_generalContent_AdvBasketManagerInfo_txtManagerPhone' # Телефон
    this.$mComment = $ '#ctl00_generalContent_AdvbasketAdditional_onlineComment_TbComment' # Комментарий

  constructor: ->
    @priceKey = h.getUrlVariable('priceKey')

  registerObserver: ->
    console.log 'Registering Basket Observer...'
    @observing = true
    @observer = new Observer('ctl00_generalContent_UpdatePanel1', 'dom', (mutation) =>
      console.log 'change', mutation
      @observer.stop()
      @applyStyles()
    )

  test: ->
    setTimeout ->
      $('.txtLastName input').val 'TestLastname'
      $('.txtFirstName input').val 'TestFirstname'
      $('.txtLastNameRus input').val 'ТестоваяФамилия'
      $('.txtFirstNameRus input').val 'ТестовоеИмя'
      $('.txtPatronymicRus input').val 'ТестовоеОтчество'

      $('.txtBirthPlace input').val 'Москва'
      $('.txtEmail input').val 'test@test.test'
      $('.txtPhone input').val '+79991230101'

      $('.sdtBirthDate input').eq(0).val '11'
      $('.sdtBirthDate input').eq(1).val '11'
      $('.sdtBirthDate input').eq(2).val '1991'

      $('.sdtPassportDateEnd input').eq(0).val '11'
      $('.sdtPassportDateEnd input').eq(1).val '11'
      $('.sdtPassportDateEnd input').eq(2).val '2022'

      $('.pPassportRus input').eq(0).val '4507'
      $('.pPassportRus input').eq(1).val '123321'
      $('.pPassport input').eq(0).val '12345'
      $('.pPassport input').eq(1).val '321123'

      $('.ddlSex select').val '0,0'
    , 500

  applyStyles: =>
    router = require './../components/router'
    test = router.test()
    if test
      @test()
#    return

    console.log 'Применяю стили Basket'
    @elements()

#    $('body').addClass('basket')

    $form = this.$form
    $panel = this.$panel

    $form.append $panel

    # Блок "Бронирование"
    h.h1('Бронирование', 'h1-booking').appendTo $panel
    [$booking, this.$bookingContent] = h.rowN(true, 'booking-content')
    $booking.appendTo $panel
    @booking()

    # Блок "Услуги"
    h.h1('Услуги', 'h1-services').appendTo $panel
    [$services, this.$servicesContent] = h.rowN(true, 'services-content')
    $services.appendTo $panel
    @services()

    # Блок "Информация о туристах"
    h.h1('Информация о туристах', 'h1-tourists').appendTo $panel
    [$tourists, this.$touristsContent] = h.rowN(true, 'tourists-content')
    $tourists.appendTo $panel
    @tourists()

    $tourist = $ '<div/>',
      class: 'tourist-item'
    this.$touristsContent.append($tourist)

    $data = $ '<div/>',
      class: 'tourist-data comments'
    $tourist.append(h.h2('Введите данные менеджера ', 'h2-tourist h2-comments'))
    $tourist.append $data

    [$columns, $left, $right] = h.columnsLR()
    $left.append '<label>ФИО менеджера</label>'
    $left.append this.$mFIO
    $right.append '<label>Телефон менеджера</label>'
    $right.append this.$mPhone
    $data.append $columns
    $div = $ '<div/>'
    $data.append $div
    $div.append '<label>Комментарий</label>'
    $div.append this.$mComment

    [$submit, $wrapper] = h.rowN(true, 'submit-content')
    $submit.appendTo $panel

    $submitBtn = $('<input type="submit" class="btn large" value="Бронировать">')
    $submitBtn.appendTo $wrapper
    $submitBtn.click (e) =>
      e.preventDefault()
      this.$submitButton.click()

    # Кнопка "Пересчитать"
    #ctl00_generalContent_BasketPrice_BtnCalculate

    # "Необходимые доплаты"
    #ctl00_generalContent_BasketRequired_DgRequiredServices
#    $('#ctl00_generalContent_BasketRequired_DgRequiredServices').appendTo $booking

    # Переписка с менеджером
    #ctl00_generalContent_AdvBasketManagerInfo_txtManagerFIO # ФИО
    #ctl00_generalContent_AdvBasketManagerInfo_txtManagerPhone # Телефон
    #ctl00_generalContent_AdvbasketAdditional_onlineComment_TbComment # Комментарий

    # Кнопка "Оформить" (забронировать)
    #ctl00_generalContent_BtnOrder
    if @observer
      console.log 'obs', @observer
      @observer.start()
    if not @observing
      @registerObserver()
    loader.hide()

    $(document).off('change.warn').on 'change.warn', '.ddlCitizenship select', (e) ->
      $selected = $(this).find('option:selected')
      if $selected.text() != 'Россия'
        alert('Пункт пропуска «Красная Горка» (Смоленская обл.) между РФ и Беларусью рассчитан исключительно на проезд граждан России и Белоруссии. Пересечение этого пункта как на поезде, так и автотранспорте (автобусе) гражданами других стран нелегитимно. Участие иностранных граждан в турах с пересечением Беларуси (туры в Европу, Прибалтику, Скандинавию через Беларусь, туры в Беларусь), возможно только авиасообщением с прилётом/вылетом в/из Минска!')

  services: ->
#    $panel =
    $table = $('#ctl00_generalContent_BasketServices_DgBasketServices')
    $table.appendTo this.$servicesContent
#    @addTouristsBtn()
#    @moveCart()
#    @cart()

  observe: ->
    console.log 'something changed (observed)'
    @booking()
#    @moveCart()
#    @tourists()

  addTouristsBtn: ->
    $addTouristsBtn = $('<div class="btn large"><img src="' + images_url + 'icon_add_tourists.svg">Добавить туристов</div>')
    $('.h2-cart').append $addTouristsBtn
    $addTouristsBtn.click ->
      console.log 'add tourists click'
      $.fancybox.open([
        {
          href: '#ctl00_generalContent_UpdatePanel2',
          closeBtn: true,
        }
      ], {
        padding : 20,
        width: 590,

      })

  booking: ->
    $cont = this.$bookingContent

    $block = $ '<div/>',
      class: 'booking-1'
    $block.prependTo $cont
    # Название тура
    $name = $('<div class="booking-tour-name-block"><div class="image-container"><img src="' + images_url + 'icon_map.svg"></div><h3>Тур:</h3></div>')
    $block.append($name)
    $name.append($('#ctl00_generalContent_BasketController_LbTour'))

    # Стоимость
    $price = $('<div class="booking-price-block"><img src="' + images_url + 'icon_wallet.svg"><div>Стоимость тура: <span class="full_price"></span></div><div>К оплате: <span class="to_pay"></span></div></div>')
    $block.append($price)
    $recalcBtn = $('#ctl00_generalContent_BasketPrice_BtnCalculate')
    $('.booking-price-block').append $recalcBtn
    $recalcBtn.val('Пересчитать')

    $('.full_price').text(@getFullPrice())
    $('.to_pay').text(@getToPay())

    [$columns, $left, $right] = h.columnsLR()
    $columns.appendTo $cont
    [$cols, $l, $r] = h.columnsLR('dates')
    $left.append $cols

    $l.append '<h3>Даты заезда</h3>'
    $l.append $('#ctl00_generalContent_BasketController_MultiDatePicker_TxtMultiDatepicker')
    $l.append $('#ctl00_generalContent_BasketController_MultiDatePicker_PopMultiCalendar_Control')
    $l.append '&nbsp;&nbsp;&mdash;&nbsp;&nbsp;'
    $l.append $('#ctl00_generalContent_BasketController_LbTourDateEnd')

    $r.append '<h3>Продолжительность</h3>'
    $r.append $('#ctl00_generalContent_BasketController_TxtDuration') # сколько (дней)
    $r.append $('#ctl00_generalContent_BasketController_LbTitle4') # дней

#    $left.append $('.frontPanel').eq(0)

    $right.append $('<p><b>Стоимость услуг изменяется в соответствии с теущим курсом компании. Оплата производится в рублях по опубликованной цене в день оплаты.</b></p><p>Выбор мест в автобусе Вы сможете осуществить сразу после нажатия на кнопку "Оформить".</p><p>Бронируйте экскурсии с выгодой при оформлении тура. Покупка экскурсий на маршруте не гарантирована.</p>')

    @snapPrices() # call to parent (SimpleBasket)

  cart: ->
    $('#ctl00_generalContent_UpdatePanel2').closest('tr').hide()
    $included = $('<table class="table-included"><tr><td><span class="h3">В состав тура включено:</span></td><td><ul class="included"></ul></td></tr></table>')
    $('#ctl00_generalContent_ShoppingCart').after($included)
    @getIncludedServices (services) ->
      for service in services
        $li = $('<li></li>').html(service)
        $('.included').append($li)

  tourists: ->
#    $('#ctl00_generalContent_UpdatePanel5').after($('.h1-tourists')) #TODO: создавать сразу на месте
#    $('.h1-tourists').after($('#ctl00_generalContent_UpdatePanel7'))
#    $cont = $('#ctl00_generalContent_UpdatePanel7')
    $cont = this.$touristsContent
#    $cont.find('table').hide() # Таблица со списком туристов
#!!!    $cont.after($('#ctl00_generalContent_upNotes'))

    $('#ctl00_generalContent_PnNotes').prepend($('#ctl00_generalContent_revNotes')) # Сообщение об ошиибке?
    $('#ctl00_generalContent_PnNotes').prepend($('#ctl00_generalContent_TxtAdditionalInformation'))
    $('#ctl00_generalContent_PnNotes').prepend(h.h2('Примечание к заявке'))
    $('#ctl00_generalContent_PnNotes table').hide() # Надпись "Примечание к заявке"
    @tourists_list()

  tourists_list: ->
    $cont = $('<div class="tourists-list"></div>')
#    $cont.prependTo($('#ctl00_generalContent_UpdatePanel1'))
    $cont.appendTo this.$touristsContent

    $table = $('#ctl00_generalContent_BasketTourists_touristData_dgTourists')
    $rows = $table.find('tr')
    headers = {}
    $rows.each (i, e) ->
      if i == 0
        $cols = $(e).find('td')
        $cols.each (index, elem) ->
          headers[index] = $(elem).html().replace('<br>', ' ')
        console.log 'headers', headers
      else
        $tourist = $ '<div/>',
          class: 'tourist-item'
        $cont.append($tourist)

        $data = $ '<div/>',
          class: 'tourist-data'
        $tourist.append(h.h2('<img src="' + images_url + 'icon_tourist.svg">Турист ' + i, 'h2-tourist'))
        $tourist.append $data

        $cols = $(e).find('td')
        $cols.each (index, elem) ->
          header = headers[index]
          content = $(elem).children()
          field_class = 'none'
          $input = $(elem).find('select, input')
          if $input
            input_name = $input.attr('name')
            if input_name
              tmp = input_name.split('$')
              field_class = tmp[tmp.length - 1]
              if field_class == 'txtDay'
                field_class += ' ' + tmp[tmp.length - 2]
              if field_class == 'txtPassportSeries'
                field_class += ' ' + tmp[tmp.length - 2]

          if header.match(/^Доплаты/)
            field_class += ' ' + 'additional_payments'
          if header.match(/^Виза/)
            field_class += ' ' + 'visa'
          if header.match(/^Скидки/)
            field_class += ' ' + 'discounts'
          if header.match(/^Групповой трансфер/)
            field_class += ' ' + 'transfer'
          if header.match(/^Страховка/)
            field_class += ' ' + 'insurance'
          $row = $('<div class="' + field_class + '"><label>' + header + '</label></div>')

          $row.append(content)
          $data.append($row)

        $common = $ '<div/>',
          class: 'block-common'
        $data.append($common)

        $common.append('<h3>Введите данные туриста:</h3>')
        $common.append('<span class="red"><b>ВНИМАНИЕ!</b> Внесение недостоверных паспортных данных может привести к ДОПОЛНИТЕЛЬНЫМ финансовым затратам (за переписку ж/д, авиабилетов и т.д.), которые возлагаются на агентство, указавшее неверные данные.</span>')

        $columns = $ '<div/>',
          class: 'columns'
        $left = $ '<div/>',
          class: 'col-1'
        $right = $ '<div/>',
          class: 'col-2'
        $columns.append($left)
        $columns.append($right)
        $common.append($columns)

        $data.find('.txtLastNameRus').appendTo($left)
        $data.find('.txtFirstNameRus').appendTo($left)
        $data.find('.txtPatronymicRus').appendTo($left)
        $data.find('.txtLastName').appendTo($left)
        $data.find('.txtFirstName').appendTo($left)
        $data.find('.txtFirstName').appendTo($left)

        $birth = $data.find('.sdtBirthDate').appendTo($right).find('label')
        $font = $birth.find('font')
        if $font
          $label = $('<label>День рождения</label>')
          $label.append($font)
          $birth.replaceWith($label)
        $data.find('.ddlSex').appendTo($right)
        $data.find('.txtBirthPlace').appendTo($right)
        $data.find('.txtEmail').appendTo($right)
        $data.find('.txtPhone').appendTo($right)

        $passports = $ '<div/>',
          class: 'block-passports'
        $data.append($passports)

        $columns = $ '<div/>',
          class: 'columns'
        $left = $ '<div/>',
          class: 'col-1'
        $right = $ '<div/>',
          class: 'col-2'
        $columns.append($left)
        $columns.append($right)
        $passports.append($columns)

        $data.find('.pPassportRus').appendTo($left)
        $data.find('.ddlCitizenship').appendTo($left)

        $data.find('.pPassport').appendTo($right)
        $data.find('.sdtPassportDateEnd').appendTo($right)

        $more = $ '<div/>',
          class: 'block-more'
        $data.append($more)

        $columns = $ '<div/>',
          class: 'columns'
        $left = $ '<div/>',
          class: 'col-1'
        $right = $ '<div/>',
          class: 'col-2'
        $columns.append($left)
        $columns.append($right)
        $more.append('<h3>Введите услуги на туриста:</h3>')
        $more.append($columns)

        $data.find('.ctl00').appendTo($left)
        $data.find('.ctl01').appendTo($right)
        $data.find('.ctl02').appendTo($left)
        $data.find('.ctl03').appendTo($right)
        $data.find('.ctl04').appendTo($left)
        $data.find('.ctl05').appendTo($right)
        $data.find('.ctl06').appendTo($left)
        $data.find('.ctl07').appendTo($right)
        $data.find('.ctl08').appendTo($left)
        $data.find('.ctl09').appendTo($right)
        unless $left.children().length + $right.children().length
          $more.hide()

#      $cols = $(e).find('td')
#      $cols.each (ii, ee) ->
#        console.log $(ee).text()

  getFullPrice: ->
    price = $('#ctl00_generalContent_BasketPrice_LbFullPrice').text()
    currency = $('#ctl00_generalContent_LbRateToPay').text()
    price + currency

  getToPay: ->
    price = $('#ctl00_generalContent_BasketPrice_LbForPayPrice').text()
#    currency = $('#ctl00_generalContent_LbRateToPay').text()
#    price + currency
    price

  getIncludedServices: (cb) ->
    # портировано из старой версии
    $.getJSON backend_url + "/index.php?r=tours/GetAcctypeServices&PriceKey=" + @priceKey + "&fromOnline=1&jsoncallback=?", (data) ->
      lines = []
      for result in data.result
        text = result.Name;

        if ($('#ctl00_generalContent_lbFlightTariffChanged').length && result.Class == 'FlightService')
          continue;

        if (result.Class == 'HotelService' && result.Country != 460 && result.shortName)
          text = result.shortName

        if result.Class == 'HotelService' && result.Country == 460 && result.Name.indexOf('Измайлово') != -1
          text = result.serviceModel.name

        if (result.Class == 'ExcursionService' || result.Class == 'TransferService') && result.shortName
          text = result.shortName

        if result.Class == 'AdditionalService' && result.ServiceClassID == 1504
          continue

        lines.push(text)

      cb(lines)

module.exports = new Basket